import React, { useState, useEffect } from "react";
import { Field, useFormik, FormikProvider } from "formik";
import { Form } from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import { Link, useNavigate } from "react-router-dom";
import {
  POST_GetUpdateScopeParameterNABLTestMethodRangeList,
  POST_UpdateScopeParameterNABLTestMethodRangeUpdate,
} from "../../../helpers/url_helper";
import { post } from "../../../helpers/api_helper";
import * as Yup from "yup";
import { Spin } from "antd";
import { errorMessage, successMessage } from "../CommonFunctions";

const UpdateScope = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  useEffect(() => {
    getUpdateScopeParameterNABLTestMethodRangeList();
  }, []);

  const validationSchemaUpdateScope = Yup.object().shape({});

  const formikUpdateScope = useFormik({
    validationSchema: validationSchemaUpdateScope,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitUpdateScope(values, formikHelpers),
    initialValues: {
      UpdateScopeList: [],
      ParameterNameSearch: "",
      TestMethodSearch: "",
      DepartmentSearch: "",
      ProductGroupSearch: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      UpdateScopeList,
      ParameterNameSearch,
      TestMethodSearch,
      DepartmentSearch,
      ProductGroupSearch,
    },
  } = formikUpdateScope;

  const handleValidSubmitUpdateScope = async (values) => {
    setIsLoading(true);

    let ParameterNABLTestMethodRangeList = [];

    values?.UpdateScopeList.filter((x) => x.IsSelected == true)?.map((item) => {
      ParameterNABLTestMethodRangeList = [
        ...ParameterNABLTestMethodRangeList,
        {
          ParameterIDEncrypt: item?.ParameterIDEncrypt,
          ProductGroupIDEncrypt: item?.ProductGroupIDEncrypt,
          TestMethodIDEncrypt: item?.TestMethodIDEncrypt,
          ParameterNABLTestMethodRangeIDEncrypt:
            item?.ParameterNABLTestMethodRangeIDEncrypt,
          NABLRangeFrom: item?.NABLRangeFrom
            ? item?.NABLRangeFrom.toString()
            : "",
          NABLRangeTo: item?.NABLRangeTo ? item?.NABLRangeTo.toString() : "",
          IsSelected: item?.IsSelected,
        },
      ];
    });

    let payload = {
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      ListOfParameter: ParameterNABLTestMethodRangeList,
    };

    post(POST_UpdateScopeParameterNABLTestMethodRangeUpdate, payload)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/dashboard");
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getUpdateScopeParameterNABLTestMethodRangeList = async () => {
    setIsLoading(true);
    await post(POST_GetUpdateScopeParameterNABLTestMethodRangeList, {
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikUpdateScope.setFieldValue(
            "UpdateScopeList",
            response?.List?.map((item) => ({
              ParameterIDEncrypt: item?.ParameterIDEncrypt,
              ProductGroupIDEncrypt: item?.ProductGroupIDEncrypt,
              TestMethodIDEncrypt: item?.TestMethodIDEncrypt,
              ParameterNABLTestMethodRangeIDEncrypt:
                item?.ParameterNABLTestMethodRangeIDEncrypt,
              ParameterName: item?.ParameterName,
              NABLRangeFrom: item?.NABLRangeFrom,
              NABLRangeTo: item?.NABLRangeTo,
              ParameterResultTypeName: item?.ParameterResultTypeName,
              ParameterResultType: item?.ParameterResultType,
              IsNABLStatus: item?.IsNABLStatus,
              ProductGroupName: item?.ProductGroupName,
              TestMethod: item?.TestMethod,
              Department: item?.Department,
              IsSelected: item?.IsSelected,
              display: true,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleChangeSearch = async (
    ParameterNameSearchText,
    TestMethodSearchText,
    DepartmentSearchText,
    ProductGroupSearchText,
  ) => {
    let newList = UpdateScopeList?.filter((x, ix) => x.IsSelected == true);

    let newFinalList = UpdateScopeList?.filter(
      (x, ix) => x.IsSelected == false,
    )?.map((x) => {
      if (
        x?.ParameterName?.toLowerCase().includes(
          ParameterNameSearchText?.toLowerCase(),
        ) &&
        x?.TestMethod?.toLowerCase().includes(
          TestMethodSearchText?.toLowerCase(),
        ) &&
        x?.Department?.toLowerCase().includes(
          DepartmentSearchText?.toLowerCase(),
        ) &&
        x?.ProductGroupName?.toLowerCase().includes(
          ProductGroupSearchText?.toLowerCase(),
        )
      ) {
        return { ...x, display: true };
      } else {
        return { ...x, display: false };
      }
    });

    formikUpdateScope.setFieldValue("UpdateScopeList", [
      ...newList,
      ...newFinalList,
    ]);
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Update Scope</h4>
              </div>

              <div className="p-2 pt-0 pb-0">
                <FormikProvider value={formikUpdateScope}>
                  <Form onSubmit={formikUpdateScope.handleSubmit}>
                    <div className="card-body p-1">
                      <div className="table-responsive active-projects style-1 shorting">
                        <div
                          id="StandardParameters-tbl_wrapper"
                          className="dataTables_wrapper no-footer"
                          style={{ height: "720px" }}
                        >
                          <table
                            id="StandardParameters-tbl"
                            className="table dataTable no-footer mb-0"
                          >
                            <thead className="fixedheader">
                              <tr>
                                <th width="3%" className="p-1"></th>
                                <th width="3%" className="p-1"></th>
                                <th width="20%" className="p-1">
                                  Parameter Name
                                </th>
                                <th width="20%" className="p-1">
                                  Material Group
                                </th>
                                <th width="20%" className="p-1">
                                  Test Method
                                </th>
                                <th width="24%">Department</th>
                                <th width="8%" style={{ whiteSpace: "normal" }}>
                                  Parameter Result Type
                                </th>
                                <th width="10%" className="p-1">
                                  NABL
                                </th>
                                <th width="8%" className="p-1">
                                  NABL Range From
                                </th>
                                <th
                                  width="8%"
                                  className="p-1"
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  NABL Range To
                                </th>
                              </tr>
                              <tr>
                                <th width="3%" className="p-1 pt-0">
                                  Sr No.
                                </th>
                                <th width="3%" className="p-1 pt-0"></th>
                                <th width="20%" className="p-1 pt-0">
                                  <Field
                                    name="ParameterNameSearch"
                                    placeholder={"Search Parameter Name"}
                                    component={CustomInput}
                                    required
                                    maxLength={100}
                                    noMarginBottom={true}
                                    style={{ height: "2.3rem" }}
                                    onChange={(e) => {
                                      formikUpdateScope.setFieldValue(
                                        "ParameterNameSearch",
                                        e?.target?.value ?? "",
                                      );
                                      handleChangeSearch(
                                        e?.target?.value ?? "",
                                        TestMethodSearch
                                          ? TestMethodSearch
                                          : "",
                                        DepartmentSearch
                                          ? DepartmentSearch
                                          : "",
                                        ProductGroupSearch
                                          ? ProductGroupSearch
                                          : "",
                                      );
                                    }}
                                  />
                                </th>
                                <th width="20%" className="p-1 pt-0">
                                  <Field
                                    name="ProductGroupSearch"
                                    placeholder={"Search Material Group"}
                                    component={CustomInput}
                                    required
                                    maxLength={100}
                                    noMarginBottom={true}
                                    style={{ height: "2.3rem" }}
                                    onChange={(e) => {
                                      formikUpdateScope.setFieldValue(
                                        "ProductGroupSearch",
                                        e?.target?.value ?? "",
                                      );
                                      handleChangeSearch(
                                        ParameterNameSearch
                                          ? ParameterNameSearch
                                          : "",
                                        TestMethodSearch
                                          ? TestMethodSearch
                                          : "",
                                        DepartmentSearch
                                          ? DepartmentSearch
                                          : "",
                                        e?.target?.value ?? "",
                                      );
                                    }}
                                  />
                                </th>
                                <th width="20%" className="p-1 pt-0">
                                  <Field
                                    name="TestMethodSearch"
                                    placeholder={"Search Test Method"}
                                    component={CustomInput}
                                    required
                                    maxLength={100}
                                    noMarginBottom={true}
                                    style={{ height: "2.3rem" }}
                                    onChange={(e) => {
                                      formikUpdateScope.setFieldValue(
                                        "TestMethodSearch",
                                        e?.target?.value ?? "",
                                      );
                                      handleChangeSearch(
                                        ParameterNameSearch
                                          ? ParameterNameSearch
                                          : "",
                                        e?.target?.value ?? "",
                                        DepartmentSearch
                                          ? DepartmentSearch
                                          : "",
                                        ProductGroupSearch
                                          ? ProductGroupSearch
                                          : "",
                                      );
                                    }}
                                  />
                                </th>
                                <th width="24%" className="p-1 pt-0">
                                  <Field
                                    name="DepartmentSearch"
                                    placeholder={"Search Department"}
                                    component={CustomInput}
                                    required
                                    maxLength={100}
                                    noMarginBottom={true}
                                    style={{ height: "2.3rem" }}
                                    onChange={(e) => {
                                      formikUpdateScope.setFieldValue(
                                        "DepartmentSearch",
                                        e?.target?.value ?? "",
                                      );
                                      handleChangeSearch(
                                        ParameterNameSearch
                                          ? ParameterNameSearch
                                          : "",
                                        TestMethodSearch
                                          ? TestMethodSearch
                                          : "",
                                        e?.target?.value ?? "",
                                        ProductGroupSearch
                                          ? ProductGroupSearch
                                          : "",
                                      );
                                    }}
                                  />
                                </th>
                                <th className="p-1 pt-0"></th>
                                <th className="p-1 pt-0"></th>
                                <th className="p-1 pt-0"></th>
                                <th className="p-1 pt-0"></th>
                              </tr>
                            </thead>
                            <tbody>
                              {UpdateScopeList?.filter((x) => x.display == true)
                                ?.length > 0 ? (
                                UpdateScopeList?.map((item, indx) => (
                                  <>
                                    <tr
                                      key={indx}
                                      style={{
                                        display:
                                          item.display == true ? "" : "none",
                                      }}
                                    >
                                      <td>{indx + 1}</td>
                                      <td>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id={`chkIsSelected${indx}`}
                                          name={`chkIsSelected${indx}`}
                                          checked={item.IsSelected}
                                          onChange={(e) => {
                                            formikUpdateScope.setFieldValue(
                                              `UpdateScopeList[${indx}].IsSelected`,
                                              e?.target?.checked,
                                            );
                                          }}
                                        />
                                      </td>
                                      <td>{item?.ParameterName}</td>
                                      <td>{item?.ProductGroupName}</td>
                                      <td>{item?.TestMethod}</td>
                                      <td
                                        style={{
                                          whiteSpace: "normal",
                                        }}
                                      >
                                        {item.Department}
                                      </td>
                                      <td>{item?.ParameterResultTypeName}</td>
                                      <td>{item?.IsNABLStatus}</td>
                                      <td
                                        style={{
                                          textAlign: "left",
                                        }}
                                      >
                                        <Field
                                          type="number"
                                          name={`UpdateScopeList.[${indx}].NABLRangeFrom`}
                                          component={CustomInput}
                                          placeholder="NABL Range From"
                                          noMarginBottom={true}
                                          style={{ width: "150px" }}
                                          disabled={
                                            item?.ParameterResultType == 2
                                              ? true
                                              : false
                                          }
                                          onChange={(e) => {
                                            const selectedvalue =
                                              e?.target?.value ?? "";
                                            formikUpdateScope.setFieldValue(
                                              `UpdateScopeList[${indx}].NABLRangeFrom`,
                                              selectedvalue,
                                            );

                                            formikUpdateScope.setFieldValue(
                                              `UpdateScopeList[${indx}].IsSelected`,
                                              true,
                                            );
                                          }}
                                        />
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "left",
                                        }}
                                      >
                                        <Field
                                          type="number"
                                          name={`UpdateScopeList.[${indx}].NABLRangeTo`}
                                          component={CustomInput}
                                          placeholder="NABL Range To"
                                          noMarginBottom={true}
                                          style={{ width: "150px" }}
                                          disabled={
                                            item?.ParameterResultType == 2
                                              ? true
                                              : false
                                          }
                                          onChange={(e) => {
                                            const selectedvalue =
                                              e?.target?.value ?? "";
                                            formikUpdateScope.setFieldValue(
                                              `UpdateScopeList[${indx}].NABLRangeTo`,
                                              selectedvalue,
                                            );
                                            formikUpdateScope.setFieldValue(
                                              `UpdateScopeList[${indx}].IsSelected`,
                                              true,
                                            );
                                          }}
                                        />
                                      </td>
                                    </tr>
                                  </>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan={9}
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    <div>{"No Record Found..."}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <hr className="mt-0 mb-1"></hr>
                    <div className="stickyBottomButtons">
                      <button
                        type="submit"
                        className="btn btn-primary btn-sm me-2"
                      >
                        <i className="fa-solid fa-floppy-disk"></i> Submit
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={(e) => {
                          navigate("/dashboard");
                        }}
                      >
                        <i className="fa fa-cancel"></i> Cancel
                      </button>
                    </div>
                  </Form>
                </FormikProvider>
                {/* </div> */}
              </div>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default UpdateScope;
